import { createFileRoute } from '@tanstack/react-router'
import MicrolearningDetailPage from '@/pages/resources/microlearnings/detail'

export const Route = createFileRoute('/app/resources/microlearnings/$id')({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return <MicrolearningDetailPage id={Number(id)} />
}
